import {
    CLEAR_FARM_RECORD_DETAILS,
    CLEAR_FARM_RECORD_LIST,
    SET_FARM_RECORD_DETAILS,
    SET_FARM_RECORD_LIST,
    FARM_RECORD_DETAILS_ERROR,
    FARM_RECORD_DETAILS_ERROR_CLEAR,
    FARM_RECORD_DETAILS_PENDING,
    FARM_RECORD_LIST_ERROR,
    FARM_RECORD_LIST_ERROR_CLEAR,
    FARM_RECORD_LIST_PENDING,
    LAB_RECORDS_PENDING,
    SET_LAB_RECORDS,
    LAB_RECORDS_ERROR,
    LAB_RECORDS_ERROR_CLEAR,
    CLEAR_LAB_RECORDS,
    FARM_RECORDS_EXPORT_PENDING,
    FARM_RECORDS_EXPORT_ERROR,
    FARM_RECORDS_EXPORT_ERROR_CLEAR,
    SET_OVERALL_SUMMARY,
    CLEAR_OVERALL_SUMMARY,
    OVERALL_SUMMARY_PENDING,
    OVERALL_SUMMARY_ERROR,
    OVERALL_SUMMARY_ERROR_CLEAR,
    FARM_RECORDS_FILTER_DIALOG_OPEN,
    FARM_RECORDS_FILTER_DIALOG_CLOSE,
    SET_FARM_RECORDS_FILTER_DATA,
} from "./constants"

const initialState = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    farmRecordList: null,
    farmRecordListCount: 0,
    isFarmRecordListPending: false,
    farmRecordListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isFarmRecordsFilterDialogOpen: false,
    farmRecordsFilterData: null,
    //-----------------------------|| OVERALL SUMMARY ||----------------------------------------------------
    overallSummaryList: null,
    isOverallSummaryPending: false,
    overallSummaryErrorMessage: null,
    //-----------------------------|| EXPORT ||------------------------------------------------------------
    isFarmRecordsExportPending: false,
    farmRecordsExportErrorMessage: null,
    //-----------------------------|| DETAILS ||------------------------------------------------------------
    farmRecordDetails: null,
    isFarmRecordDetailsPending: false,
    farmRecordDetailsErrorMessage: null,
    //-----------------------------||LAB RECORDS LIST ||----------------------------------------------------
    isLabRecordSPending: false,
    labRecordsErrorMessage: null,
    labRecords: null,
    labRecordsCount: 0,
}

const farmRecords = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case FARM_RECORD_LIST_PENDING: {
            return {
                ...state,
                isFarmRecordListPending: true,
                farmRecordListErrorMessage: null,
            }
        }

        case SET_FARM_RECORD_LIST: {
            const { farmRecordList } = action.payload || {};
            const { farmRecords, totalFarmRecords } = farmRecordList || {};
            return {
                ...state,
                farmRecordList: farmRecords,
                farmRecordListCount: totalFarmRecords || 0,
                isFarmRecordListPending: false,
                farmRecordListErrorMessage: null,
            }
        }

        case FARM_RECORD_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                farmRecordListErrorMessage: errorMessage,
                isFarmRecordListPending: false,
                farmRecordList: null,
                farmRecordListCount: 0,
            }
        }

        case FARM_RECORD_LIST_ERROR_CLEAR: {
            return {
                ...state,
                farmRecordListErrorMessage: null,
                isFarmRecordListPending: false,
            }
        }
        case CLEAR_FARM_RECORD_LIST: {
            return {
                ...state,
                farmRecordList: null,
                farmRecordListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case FARM_RECORDS_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isFarmRecordsFilterDialogOpen: true,
            }
        }
        case FARM_RECORDS_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isFarmRecordsFilterDialogOpen: false,
            }
        }

        case SET_FARM_RECORDS_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                farmRecordsFilterData: filter,
            }
        }

        //-----------------------------|| OVERALL SUMMARY ||----------------------------------------------------
        case OVERALL_SUMMARY_PENDING: {
            return {
                ...state,
                isOverallSummaryPending: true,
                overallSummaryErrorMessage: null,
            }
        }

        case SET_OVERALL_SUMMARY: {
            const { overallSummary } = action.payload || {};
            return {
                ...state,
                overallSummaryList: overallSummary,
                isOverallSummaryPending: false,
                overallSummaryErrorMessage: null,
            }
        }

        case OVERALL_SUMMARY_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                overallSummaryErrorMessage: errorMessage,
                isOverallSummaryPending: false,
                overallSummaryList: null,
            }
        }

        case OVERALL_SUMMARY_ERROR_CLEAR: {
            return {
                ...state,
                overallSummaryErrorMessage: null,
            }
        }
        case CLEAR_OVERALL_SUMMARY: {
            return {
                ...state,
                overallSummaryList: null,
            }
        }

        //-----------------------------|| EXPORT ||-------------------------------------------------------------
        case FARM_RECORDS_EXPORT_PENDING: {
            return {
                ...state,
                isFarmRecordsExportPending: true,
                farmRecordsExportErrorMessage: null,
            }
        }

        case FARM_RECORDS_EXPORT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                farmRecordsExportErrorMessage: errorMessage,
                isFarmRecordsExportPending: false,
            }
        }

        case FARM_RECORDS_EXPORT_ERROR_CLEAR: {
            return {
                ...state,
                farmRecordsExportErrorMessage: null,
                isFarmRecordsExportPending: false,
            }
        }
        //-----------------------------|| DETAILS ||---------------------------------------------------------------
        case FARM_RECORD_DETAILS_PENDING: {
            return {
                ...state,
                isFarmRecordDetailsPending: true,
                farmRecordDetailsErrorMessage: null,
            }
        }

        case SET_FARM_RECORD_DETAILS: {
            const { farmRecordDetails } = action.payload || {};
            return {
                ...state,
                farmRecordDetails: farmRecordDetails,
                isFarmRecordDetailsPending: false,
                farmRecordDetailsErrorMessage: null,
            }
        }

        case FARM_RECORD_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                farmRecordDetailsErrorMessage: errorMessage,
                isFarmRecordDetailsPending: false,
                farmRecordDetails: null,
            }
        }

        case FARM_RECORD_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                farmRecordDetailsErrorMessage: null,
                //  isFarmRecordDetailsPending: false,
            }
        }
        case CLEAR_FARM_RECORD_DETAILS: {
            return {
                ...state,
                farmRecordDetails: null,
            }
        }

        //-----------------------------||LAB RECORDS LIST ||---------------------------------------------------------------
        case LAB_RECORDS_PENDING: {
            return {
                ...state,
                isLabRecordSPending: true,
                labRecordsErrorMessage: null,
            }
        }

        case SET_LAB_RECORDS: {
            const { labRecords } = action.payload || {};
            return {
                ...state,
                labRecords: labRecords['value'],
                labRecordsCount: labRecords['@odata.count'],
                isLabRecordSPending: false,
                labRecordsErrorMessage: null,
            }
        }

        case LAB_RECORDS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                labRecordsErrorMessage: errorMessage,
                isLabRecordSPending: false,
                labRecordList: null,
                labRecordListCount: 0,
            }
        }

        case LAB_RECORDS_ERROR_CLEAR: {
            return {
                ...state,
                labRecordsErrorMessage: null,
                isLabRecordSPending: false,
            }
        }
        case CLEAR_LAB_RECORDS: {
            return {
                ...state,
                labRecords: null,
                labRecordsCount: 0,
            }
        }

        default: {
            return state;
        }
    }
}

export default farmRecords;